import { ApiCase } from "./case.model";
import { ApiCompany } from "./company.model";
import { ApiContact } from "./contact.model";
import { ApiDeal } from "./deal.model";
import { ApiLead } from "./lead.model";
import { ApiModel } from "./model.model";

export class ApiEmail extends ApiModel {
    Company: ApiCompany;
    Contact: ApiContact;
    Lead: ApiLead;
    Deal: ApiDeal;
    Case: ApiCase;
    company_ID: string;
    contact_ID: string;
    related_type: string;
    related_ID: string;
    folder: string;
    subject: string;
    type: string;
    priority: string;
    date: string;
    time: string;
    notes: string;
    status: string;
}  


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/email.model.ts